import { Route, Routes } from 'react-router-dom'
import SelectBranch from './SelectBranch'
import LeaderBoard from './LeaderBoard'

function Main() {
  return (
    <div className="flex flex-col flex-1 h-full w-full">
      <Routes>
        <Route path="/leader-board" element={<LeaderBoard />} />
        <Route path="/*" element={<SelectBranch />} />
      </Routes>
    </div>
  )
}

export default Main
